<template>
    <div class="map-panel">

        <div id="preloaderSmall" class="preloader-small">
            <div class="circle-panel">
                <span class="spinner"></span>
            </div>
        </div>

        <template v-if="noResults === true">
            <div class="no-results-overlay">
                <h2 class="mt-5 p-5">{{ lang.noResults }}</h2>
            </div>
        </template>

        <template>
            <div id="map" class="map"></div>
        </template>

    </div>
</template>

<script>
  //Dependencies
  import {options, clusterOptions} from './config/options';
  import markerFragment from './config/marker';
  import {SaveToFavorites} from "../../../../scripts/save-to-favorites/save-to-favorites";
  import {bus} from "../filter-parent";
  import axios from 'axios';
  // import MarkerClusterer from '@google/markerclustererplus';

  const moment = require('moment');
  const langData = $('body').data().locale;
  const enPrefix = langData === 'en' ? '/en' : '';
  moment.locale(langData);

  export default {
    name: "map-create",
    props: {
      formData: '',
      offersData: '',

      authCheck: ''
    },
    data: function () {
      return {
        offers: this.offersData,
        formState: this.formData,

        authentication: this.authCheck,
        prefixEn: enPrefix,

        noResults: '',

        // Translations
        lang: jsLangs,

        // Map data
        dataSetCooridnates: [],

        map: null,
        _prevInfoWindow: null,
        _infoWindow: null,
        _bounds: null,
        _gMarkers: null,
        _markerCluster: null,

        clusterOffices: []
      }
    },
    methods: {
      /**
       * Create new marker
       * lat, long -> are used to set coordinates
       * title, address, monthly_rent, total_floorage, slug -> are used to set information inside infoWindow
       *
       * @param lat Latitude
       * @param long Longitude
       * @param offer_id Offer's id
       * @param is_favorited If it's favorite
       * @param title Title
       * @param media Media
       * @param address Address
       * @param monthly_rent Monthly rent
       * @param total_floorage Total floorage
       * @param created_at Created at
       * @param human_readable_created_at Readable for humans (created at)
       * @param slug Slug
       **/
      addMarker(lat, long, offer_id, is_favorited,
                title, media, address, monthly_rent,
                total_floorage, created_at, human_readable_created_at, slug) {
        let coordinates = new google.maps.LatLng(lat, long);
        const icon = markerFragment;
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

        const singeMarker = new google.maps.Marker({
          position: coordinates,
          map: this.map,
          // title: jsLangs.room_office, @todo: Maybe revert the line below
          title: 'office',
          visible: true,
          icon: {
            url: '/assets/images/icons/markerClustering/m1.png',
            scaledSize: (isIE11 ? new google.maps.Size(27, 27) : new google.maps.Size(21, 21))
          }
        });

        this._gMarkers.push(singeMarker);

        // On marker click
        google.maps.event.addListener(singeMarker, 'click', (function (marker, self) {
          return function () {
            let content = '';
            let newBounds = new google.maps.LatLngBounds();

            newBounds.extend(marker.position);

            // If there is an info window already opened, close it
            if (self._prevInfoWindow) {
              self._prevInfoWindow.close();
            }

            // Init 'SaveToFavorites'
            SaveToFavorites();

            let addressHtml = null;
            let toFavoritesHtml = null;

            // Content Auth guard
            if (self.authentication) {
              addressHtml = `<div class="offer-location">${address}</div>`;
              toFavoritesHtml = `<span class="checkbox-star-panel"
                              data-toggle="tooltip"
                              data-original-title="${jsLangs.favorite_offers}">
                            <label class="checkbox-star"
                                   data-trigger="auth-true"
                                   data-item-key="${offer_id}">
                                <input type="checkbox"
                                       name="favourites"
                                       ${is_favorited === true ? 'checked' : 'favorite-false'}>
                                <span class="checkmark"></span>
                            </label>
                        </span>`
            } else {
              addressHtml = `<div class="offer-location d-flex align-items-center flex-wrap mb-auto">
                            <span class="text-regular mr-2">${jsLangs.location}:</span>
                            <span class="text-regular ellipsis blur-effect-soft">${jsLangs.sample_location}</span>
                        </div>`;
              toFavoritesHtml = `<span class="checkbox-star-panel checkbox-star-false"
                               data-toggle="tooltip"
                               data-original-title="${jsLangs.registration_needed_favorites}">
                            <span class="checkbox-star">
                                <span class="checkmark"></span>
                            </span>
                          </span>`;
            }
            content = `
                <div class="offer-item">
                    <div class="offer-image-panel">
                        ${toFavoritesHtml}
                        <a href="${enPrefix}/properties/${slug}" class="offer-map-image">
                            <div class="offer-image zoom" style="background-image: url('${media.length ? media[0].sizes.D : '/assets/images/placeholders/placeholder-small.jpg'}');"></div>
                        </a>
                     </div>
                     <div class="offer-info">
                            <div class="offer-title mb-auto"> ${title} </div>
                                ${addressHtml}
                                <div class="d-flex justify-content-between">
                                <div class="offer-price"> ${monthly_rent} € </div>
                                    <div class="offer-surface"> ${total_floorage ? total_floorage + ' ' + jsLangs.square_meters_abbrv : ''}</div>
                                </div>
                                <div class="offer-row-label">
                                    <a href="${enPrefix}/properties/${slug}"
                                       title="${title}"
                                       class="offer-link ml-auto">
                                        ${jsLangs.see_more}
                                    </a>
                                </div>
                            </div>
                    </div>
                </div>`;

            self._infoWindow = new google.maps.InfoWindow({content: content});
            self._prevInfoWindow = self._infoWindow;
            self._infoWindow.open(self.map, marker);
            self.map.setCenter(newBounds.getCenter());
            // self.map.setZoom(15);


            // On infowindow's close button click - zoom out and update bounds
            /*if (self._gMarkers.length > 1) {
                google.maps.event.addListener(self._infoWindow, 'closeclick', () => {
                  self.updateBounds(self._bounds);
                  self.initClusters();
                })
            }*/
          }
        })(singeMarker, this));
      },

      /**
       * Method to Update Bounds after filter
       *
       * @param bounds Bounds
       **/
      updateBounds(bounds) {
        this.map.initialZoom = true;
        this.map.setCenter(bounds.getCenter());
        this.map.fitBounds(bounds);

        let zoomChangeBoundsListener = google.maps.event.addListener(this.map, 'bounds_changed', function () {
          if (this.getZoom() > 14 && this.initialZoom) {
            this.setZoom(14);
            this.initialZoom = false;
          }
          google.maps.event.removeListener(zoomChangeBoundsListener);
        });
      },

      /**
       * Initiate clusters
       **/
      initClusters() {
        this._markerCluster = new MarkerClusterer(
          this.map,
          this._gMarkers,
          clusterOptions
        )
      },

      /**
       * Clear All Pins Before Update
       *
       * @param clusters bool should Delete clusters as well
       **/
      clearMarkers(clusters) {
        for (var i = 0; i < this._gMarkers.length; i++) {
          this._gMarkers[i].setMap(null);
        }
        this._gMarkers.length = 0;

        // Clear clusters
        if (this._markerCluster) {
          if (this._markerCluster) {
            this._markerCluster.clearMarkers();
          }
        }
      },

      /**
       * On filters or route change
       * Event bus - Watch for emitted value
       */
      stateUpdate() {
        bus.$on('searchResults', response => {
          const firstTimeClusters = !!this._markerCluster;

          this.clearMarkers(this._markerCluster);

          this.dataSetCooridnates = response.data.data;

          /**
           * Check for No Results *
           **/
          (Array.isArray(this.dataSetCooridnates) && this.dataSetCooridnates.length === 0 ? this.noResults = true : this.noResults = false);

          if (this.dataSetCooridnates !== undefined) {
            this.dataSetCooridnates.forEach(index => {
              let coordinates = new google.maps.LatLng(parseFloat(index.latitude), parseFloat(index.longitude));

              this.addMarker(
                parseFloat(index.latitude),
                parseFloat(index.longitude),
                index.id,
                index.is_favorited,
                index.title,
                index.media,
                index.address,
                index.monthly_rent,
                index.total_floorage,
                index.created_at,
                index.human_readable_created_at,
                index.slug
              );
              this._bounds.extend(coordinates);
            });
          }

          this.updateBounds(this._bounds);

          this.initClusters();

          google.maps.event.addListener(this._markerCluster, 'clusterclick', cluster => {

            /**
             * If the clusters persist (at 22 zoom) we assume that the locations are in the same building
             * Thus, the markers are pushed into 'clusterOffices' and sent to catalogue
             * In catalogue, only the selected properties are shown
             */

            if (this.map.getZoom() >= 22) {
              let idParams = 'i=';

              this.dataSetCooridnates.forEach((value, index) => {
                if (value.latitude === cluster.markers_[0].position.lat() && value.longitude === cluster.markers_[0].position.lng()) {
                  this.clusterOffices.push(value);
                  if (index < this.dataSetCooridnates.length) {
                    idParams += value.id + ',';
                  }
                }
              });

              this.$router.push({path: enPrefix + '/properties/catalogue', query: {'filter_id': idParams}})
                .then(() => {
                  console.log('redirect successful?!')
                })
                .catch(err => {
                  console.error('error~!', err)
                });
            }
          });


          // Remove loader
          setTimeout(() => $("#preloaderSmall").fadeOut('slow'), 600);
        });
      }
    },
    mounted() {
      this.map = new google.maps.Map(document.getElementById('map'), options);
      this._gMarkers = [];
      this._prevInfoWindow = false;
      this._bounds = new google.maps.LatLngBounds();


      this.stateUpdate();
      bus.$emit('componentLoaded', true);
    },
  }
</script>
